import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import SortableItem from './DragDropItem';
import { MinusCircleIcon } from '../../../Icons';
import type { TeamStaffTO } from '../../../../../lib';

interface DragDropContainerProps {
  id: number;
  items: TeamStaffTO[];
  onRemoveClick: (clinicianId: number, teamId: number) => void;
  enabledDrag: boolean;
  setToast: any;
  canEditTeam: boolean;
}
export default function DragDropContainer(props: DragDropContainerProps) {
  // id is team id
  const { id, items, onRemoveClick, enabledDrag, canEditTeam } = props;

  const { setNodeRef } = useDroppable({
    id,
  });

  // use teamId+clinician_id as unique id because staff can be cross team
  const itemWithId = items.map((item) => ({
    ...item,
    id: `${id}_${item.clinicianId}`,
    teamId: id,
  }));

  return (
    <SortableContext
      id={id.toString()}
      items={itemWithId}
      strategy={verticalListSortingStrategy}
    >
      <div ref={setNodeRef} style={{ minHeight: '25px' }}>
        {itemWithId.map((item) => (
          <div key={item.id} className="team-staff-item space-between">
            <SortableItem
              enabledDrag={enabledDrag}
              id={item.id}
              user={item}
              teamId={id}
              className={enabledDrag ? 'cursor-move' : 'cursor-auto'}
            />
            {canEditTeam && (
              <button onClick={() => onRemoveClick(item.clinicianId, id)}>
                <MinusCircleIcon size={20} className="ms-1" />
              </button>
            )}
          </div>
        ))}
      </div>
    </SortableContext>
  );
}
